export const TIMEOUT_CODE = /** @type {const} */ 'ECONNABORTED';
